module.exports = __webpack_public_path__ + "media/images/partner-4-3786cf8d1b34794a6434f63c828bb0e3.png";